import React, { ButtonHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';

import { Container } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  icon?: React.ComponentType<IconBaseProps>;
}

const Button: React.FC<ButtonProps> = ({ title, icon: Icon, ...rest }) => {
  return (
    <Container {...rest}>
      {title} {Icon && <Icon size={20} />}
    </Container>
  );
};

export default Button;
